<template>
  <div>
    <p class="caption blue-grey--text text--darken-1 ma-0 pa-0">
      {{ label }}
    </p>
    <v-chip
      v-for="item in value"
      outlined
      small
      class="me-1 mt-2"
      :key="item.text"
    >
      <span class="blue-grey--text text--darken-3 caption">{{
        item.text
      }}</span>
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'ChipAttribute',
  props: {
    label: String,
    value: Array,
  },
}
</script>
